export default "__VITE_ASSET__2d86935e__"